<template>
  <div class="display-flex flex-col items-start w-full" style="gap: 15px;">
    <div class="w-full">
      <h2>Integração com a Napp</h2>
      <p>Para integrar com a Napp, você precisa informar o usuário e a senha da Napp.</p>
    </div>

    <div v-if="!verified" class="display-flex justify-start w-full" style="gap: 15px;">
      <p>Primeiro verifique a integração:</p>
      <i-button type="primary" @click="verify" :loading="verifying">
        Verificar Integração
      </i-button>
    </div>

    <div class="w-full" v-else>
      <h4>{{ napp.id ? 'Integrado!' : 'Sem integração! Informe o usuário e senha...' }} {{ napp.deleted_at ? 'Mas inativado...' : '' }}</h4>

      <div v-if="napp.id && napp.deleted_at" class="display-flex justify-start w-full" style="gap: 15px;">
        <span>A integração está inativada. Clique no botão abaixo para ativá-la.</span>
        <i-button type="success" @click="toggleStatus" :loading="saving">
          Ativar Integração
        </i-button>
      </div>

      <div v-if="napp.id && !napp.deleted_at" class="display-flex justify-start w-full" style="gap: 15px;">
        <i-button type="error" @click="toggleStatus" :loading="saving">
          Inativar Integração
        </i-button>
      </div>

      <div class="display-flex align-center justify-center mt-3" style="gap: 15px;">
        <i-input clearable prefix="md-person" v-model="napp.username" placeholder="Coloque o usuário"></i-input>

        <i-input clearable prefix="md-lock" v-model="napp.password" placeholder="Coloque a senha"></i-input>
      </div>

      <div class="display-flex justify-end mt-4" style="gap: 15px;">
        <span v-if="errorMessage" style="color: red; font-size: 14px;">
          {{ errorMessage }}
        </span>

        <span v-if="success" style="color: green; font-size: 14px;">
          Sucesso!
        </span>

        <i-button type="primary" @click="save" :loading="saving" :disabled="(!napp.username || !napp.password) || (napp.username === nappBackup.username && napp.password === nappBackup.password)">
          Salvar
        </i-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntegrarNapp",
  props: {
    id_empresa: Number
  },
  data() {
    return {
      errorMessage: null,
      saving: false,
      verifying: false,
      verified: false,
      success: false,
      napp: {
        id: null,
        username: null,
        password: null,
        deleted_at: null,
      },
      nappBackup: {
        id: null,
        username: null,
        password: null,
        deleted_at: null,
      },
    };
  },
  methods: {
    verify() {
      this.verifying = true;

      this.$axios.get(`clientes/napp/${this.id_empresa}`)
        .then(({data}) => {
          this.verified = true;
          this.verifying = false;

          this.napp = data;
          this.nappBackup = JSON.parse(JSON.stringify(data));
        })
        .catch(err => {
          this.verifying = false;
        })
    },
    save() {
      this.success = false;
      this.errorMessage = null;

      this.saving = true;

      const form = new FormData();
      form.append('username', this.napp.username);
      form.append('password', this.napp.password);

      this.$axios.post(`clientes/napp/${this.id_empresa}`, form)
        .then(({data}) => {
          this.saving = false;

          if (data.codigo === 1) {
            this.success = true;
            this.active = true;
            this.napp = data.napp;
            this.nappBackup = JSON.parse(JSON.stringify(data.napp));
          } else {
            this.errorMessage = data.message;
          }
        })
        .catch(err => {
          this.saving = false;
          this.errorMessage = "Erro ao salvar: " + err;
        })
    },
    toggleStatus() {
      this.saving = true;

      this.$axios.post(`clientes/napp/${this.id_empresa}/status`)
        .then(({data}) => {
          this.saving = false;

          if (data.codigo === 1) {
            this.success = true;
            this.napp = data.napp;
            this.nappBackup = JSON.parse(JSON.stringify(data.napp));
          } else {
            this.errorMessage = data.message;
          }
        })
    },
  }
};
</script>

<style scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

